function initAuthManager(router) {
    return new Promise((resolve) => {
    	let token = JSON.parse(localStorage.getItem("token"));
    	if(!token) return;
    	
    	let remain = moment.duration( moment(token.expired_at).diff( moment() )).as('seconds');
    	let before10Minutes = moment(token.expired_at).subtract(10, "minutes");

    	if(remain <= 600){ // 10 minutes
    		refreshToken(token, router);
		}else{
			let after = before10Minutes.diff(moment(), "s");
			console.log("Will refresh token after "+ after + " seconds");
			setTimeout(() => { refreshToken(null, router); }, after*1000);
		}
    });
}

function refreshToken(token = null, router){
	if(!token){
		token = JSON.parse(localStorage.getItem("token"));
	}

	axios.post('/v1/admin-panel/refresh_token', {
		refresh_token: token.refresh_token,
		partner_id: process.env.VUE_APP_ID,
		partner_secret: process.env.VUE_APP_SECRET
	}, { baseURL: process.env.VUE_APP_API })
		 .then( res => {
		 	if(res.data.code == 0){
		 		res.data.data.expired_at = moment().add(res.data.data.expires_in, 'seconds');
		 		localStorage.setItem( 'token', JSON.stringify(res.data.data));

		 		let before10Minutes = moment(token.expired_at).subtract(10, "minutes");
		 		let after = before10Minutes.diff(moment(), "s");
		 		console.log("Will refresh token after "+ after + " seconds");
				setTimeout(() => { refreshToken(null, router); }, after*1000);

		 		return;
		 	}

		 	alertLogin("Phiên làm việc đã kết thúc, vui lòng đăng nhập lại!", router);
		 })
		 .catch((error) => {
		 	let mess = error.response.data.msg && error.response.data.data == null ? error.response.data.msg : "Phiên làm việc đã kết thúc, vui lòng đăng nhập lại!";
		 	alertLogin(mess, router);
		 });
}

function alertLogin(mess, router){
	localStorage.clear();
	router.replace({ name: 'LoginPage', params: { "message": mess } });
}

export { initAuthManager };